import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IrembogovBulkApplicationProgressTrackerComponent } from './irembogov-bulk-application-progress-tracker.component';
import {
  MissingTranslationHandler,
  TranslateModule,
} from '@ngx-translate/core';
import { IremboMissingTranslationHandler } from '../../../utils/utils/missing-translations-handler';

@NgModule({
  declarations: [IrembogovBulkApplicationProgressTrackerComponent],
  imports: [
    TranslateModule.forChild({
      useDefaultLang: true,
      missingTranslationHandler: {
        provide: MissingTranslationHandler,
        useClass: IremboMissingTranslationHandler,
      },
    }),
    CommonModule,
  ],
  exports: [IrembogovBulkApplicationProgressTrackerComponent],
})
export class IrembogovBulkApplicationProgressTrackerModule {}
